'use client';

import { useMentorshipProgramsList } from '@/features/mentorship';
import { trackStatistic } from '@/lib/utils/statisticTracker';
import Link from 'next/link';

export default function HomeSearchMentorshipLink() {
  const {
    data: programs = [],
    isLoading,
    isError,
  } = useMentorshipProgramsList(undefined, { excludeExpired: true });

  if (isLoading) {
    return (
      <div
        className="h-9 w-48 animate-pulse rounded-lg bg-gray-200"
        aria-hidden
      />
    );
  }

  if (isError || programs.length === 0) {
    return null;
  }

  return (
    <Link
      href="/mentorship"
      className="flex items-center p-2 text-[#555] hover:text-black rounded-lg transition-opacity hover:opacity-90"
      style={{
        background: 'linear-gradient(90deg, #0AC1CE 0%, #B4FAFF 100%)',
        boxShadow: '2px 2px 4px #e1e4e7',
      }}
      onClick={() => trackStatistic('quick_filter_mentorship')}
    >
      <span>Internship & Mentorship</span>
    </Link>
  );
}
